<template>
  <AccountOpePanel>
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 h6">{{ $t("购买历史") }}</h5>
      </div>
    </div>

    <van-tabs
        class="full-width"
        v-model="orderParam.state"
        sticky
        title-active-color="#e98c03"
        @click="clickState"
    >
      <van-tab :name="null" :title="$t('全部')"/>
      <van-tab
          v-for="(state, i) in states"
          :key="i"
          :name="state"
          :title="$t('EnumGoodsOrderState_' + state)"
      />
    </van-tabs>

    <van-tabs
         class="full-width"
        v-if="pageFrom !== 'goods' && cates.length"
        :swipe-threshold="3"
        :value="activeCateCode"
        title-active-color="#e98c03"
        @click="clickCate"
    >
      <!-- 商品目录 -->
      <van-tab
          v-if="cates && cates.length"
          :name="null"
          :title="$t('全部')"
      ></van-tab>
      <van-tab
          v-for="cate in cates"
          :key="cate.code"
          :name="cate.code"
          :title="cate.name"
      ></van-tab>
    </van-tabs>
      <van-list
           class="full-width"
          v-model="loading"
          :finished="finished"
          :finished-text="$t(`No_More_Data`)"
          @load="getList"
      >
        <template v-for="item in list">
          <div :key="item.id" class="list-group-item">
            <div class="row gutters-5 justify-content-between pb-2">
              <div class="d-flex">
                <span v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',订单列表页_创建时间,')" class="fw-600 fs-16 pr-3">{{ item.userPayTime }}</span>
<!--                && (paramMapAll['SHOP_BUYER_DISCOUNT_BUY_BACK']!=='1' || item.buybackState === 'INIT')-->
                <div v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',订单列表页_订单编号,')">
                  <span class="opacity-60 fs-14">{{ $t("订单号") }}：</span>
                  <span class="fw-600 fs-16" @click="copy_txt(item.no)">{{
                      item.no
                    }}</span>
                </div>
                <div class="opacity-60 col-auto">
                  {{ $t("EnumGoodsOrderState_" + item.state) }}
                </div>
              </div>
              <div
                  class="fw-600 fs-16"
                  @click="goto(`/shop?shopId=${item.shopId}`)"
              >
                {{ item.shopName || $t("未知商家") }}
                <i class="las la-angle-right"></i>
              </div>
            </div>
            <div class="row" style="justify-content: flex-end">
              <div v-if="item.orderItems" class="col-7">
                <div
                    v-for="orderItem in item.orderItems"
                    :key="orderItem.id"
                    class="d-flex list-group-item"
                >
                  <img
                      :src="getFileViewUrl(orderItem.goodsPic)"
                      alt
                      class="img-fit size-60px rounded mr-2 ml-0"
                      @click="
                      goto(
                        `/product?shopId=${item.shopId}&goodsId=${orderItem.goodsId}`
                      )
                    "
                  />
                  <div class="fs-14 opacity-60">
                    <div>{{ orderItem.goodsName }}</div>
                    <div
                        v-if="isValidateSpec(orderItem.goodsSpecName)"
                        class="text-primary"
                    >
                      {{ orderItem.goodsSpecName }}
                    </div>
                  </div>
                  <div>&nbsp;x&nbsp;{{ orderItem.number }}</div>
                </div>
              </div>
              <div class="col-5">
                <div class="row mb-3">
                  <div class="col">
                    <div class="list-group-item">
                      {{ formatMoney(item.money)}}
                    </div>
                   <template v-if="!['NONE','IGNORE'].includes(item.buybackState)">
                     <div>
                       <zselect v-model="item.buybackState" classname="EnumGoodsOrderBuyBackState" :is-edit="false"/>
                     </div>
                     <span>
                       {{ $t("佣金") }}: {{formatMoney(item.buybackCommission)}}
                     </span>
                   </template>
                  </div>
                  <div
                      class="col d-flex"
                      style="flex-direction: column; align-items: center"
                  >
                    <div
                        class="mb-2 link"
                        v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',订单列表页_取消未确认订单,') && item.state === 'USER_PAY'"
                        @click="cancelOrder(item)"
                    >
                      {{ $t("取消订单") }}
                    </div>
                    <div
                        class="mb-2 link"
                        v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',订单列表页_申请退款,') && canRefund(item)"
                        @click="requestRefund(item)"
                    >
                      {{ $t("申请退款") }}
                    </div>
                    <van-button
                        class="btn btn-soft-primary btn-sm fw-600 mb-2"
                        v-if="item.state === 'SHOP_PAY'"
                        :loading="loadingOrderReceipt"
                        :loading-text="$t('submitting')"
                        @click="orderReceipt(item)"
                    >
                      {{ $t("确认收货") }}
                    </van-button>
                    <van-button v-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',订单列表页_评论,') && item.state === 'SUCCESS' && item.orderItems.filter(i=>i.goodsEvaluationId).length === 0"
                                class="mb-2 btn btn-soft-primary btn-sm fw-600"
                                style="max-width:5rem;"
                                @click="goToComment(item)"
                    >
                      {{ $t("进行评论") }}
                    </van-button>
                    <div
                        v-else-if="`,${paramMapAll['HOME_BUYER_SHOW']},`.includes(',订单列表页_详情,')"
                        class="mb-2 link"
                        @click="goToComment(item)"
                    >
                      {{ $t("详情") }}
                    </div>

                    <div v-if="item.refundState === 'REFUND_FAIL'">
                      {{ $t("退款失败") }}({{ item.refundSellerDesc }})
                    </div>
                    <div v-else-if="item.refundState === 'REFUNDING'">
                      {{ $t("退款处理中") }}
                    </div>
                  </div>
                </div>
                <template v-if="item.shippingCompany && item.shippingNo">
                  <div>
                    <span class="opacity-60 fs-12">{{ $t("物流公司") }}：</span>
                    <span class="fw-600 fs-14">{{ item.shippingCompany }}</span>
                  </div>
                  <div>
                    <span class="opacity-60 fs-12">{{ $t("物流单号") }}：</span>
                    <span class="fw-600 fs-14">{{ item.shippingNo }}</span>
                  </div>
                  <div>
                    <span class="opacity-60 fs-12">{{ $t("发货时间") }}：</span>
                    <span class="fw-600 fs-14">{{ item.shippingTime }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </van-list>
<!--    </template>-->
    <CancelOrderModal
        ref="cancelOrderModal"
        :no="selectedOrderNo"
        @confirm="reload"
    />
    <RequestRefundModal
        ref="requestRefundModal"
        :no="selectedOrderNo"
        @confirm="reload"
    />
  </AccountOpePanel>
</template>

<script>
import AccountOpePanel from "@/components/AccountOpePanel.vue";
import {getListCates} from "@/api/goods";
import store from "@/store";
import {
  getGoodsOrder,
  getGoodsOrderUpdate,
  goodsOrderReceipt
} from "@/api/goodsOrder";
import {DeviceUtil} from "@/utils/deviceUtil";
import CancelOrderModal from "@/components/CancelOrderModal.vue";
import RequestRefundModal from "@/components/RequestRefundModal.vue";
import Zselect from "@/parent-ui/src/main/ui-element/zselect.vue";

export default {
  components: {
    Zselect,
    RequestRefundModal,
    CancelOrderModal,
    AccountOpePanel
  },

  async beforeRouteEnter(to, from, next) {
    await store.dispatch('common/dictListComputeIfAbsentEnum', 'EnumGoodsOrderBuyBackState')
    next((vm) => {
      // access to component public instance via `vm`
    })
  },
  computed: {
    ...Vuex.mapGetters(["userInfo", "paramMapAll", "dictEnumMapAll"]),
  },
  data() {
    return {
      init: false,
      submiting: false,
      shopId: null,
      userId: null,
      searchText: null,
      activeCateCode: null,
      cates: [],
      states: [],
      list: [],
      checkedAll: false,
      pageFrom: null, //user,goods,userShop
      token: null,
      goodsId: null,
      state: null,
      current: 1,
      size: 20,
      total: 0,
      userShop: {},
      goodsOrder: {},
      showGoodsOrderUpdate: false,
      goodsOrderUpdateType: 0,
      loading: false,
      finished: false,
      orderParam: {
        state: null
      },
      selectedOrderNo: "",
      loadingOrderReceipt: false
    };
  },
  async created() {
    await this.getStates();
    this.shopId = this.$route.query.shopId || null;
    // this.$nextTick(() => {
    // setTimeout(()=>{
    this.orderParam.state = this.$route.query.state || null;
    // },200)
    // })
    this.pageFrom = this.$route.query.pageFrom || null;
    this.goodsId = this.$route.query.goodsId || null;
    if (this.pageFrom !== "goods") {
      // this.getCateList()
    }
    this.init = true;
    if (this.pageFrom === "userShop") {
      await this.getUserShop(this.userInfo.userShopId);
    }
    await this.reload();
  },
  methods: {
    goToComment(item) {
      this.jump(`/user/order_detail?id=${item.id}&toComment=1`);
    },
    async orderReceipt(item) {
      await this.$dialog.confirm({
        title: this.$t("提示"),
        message: this.$t("确认收货"),
        confirmButtonText: this.$t("确定"),
        cancelButtonText: this.$t("取消")
      });

      this.loadingOrderReceipt = true;
      await goodsOrderReceipt(item.no);
      this.loadingOrderReceipt = false;

      this.$toast(this.$t("确认收货成功"));

      await this.reload();
    },
    async getUserShop(userShopId) {
      this.userShop = userShopId
          ? (await this.$get(`userShop/getById/${userShopId}`)).data
          : {};
    },
    async getStates() {
      const res = await this.$post(`/common/dictEnum/EnumGoodsOrderState`);
      this.states = Object.keys(res.data) || [];
    },
    async commit() {
      if (this.submiting) {
        return;
      }
      this.submiting = true;
      let ordersSelected = this.list.filter(o => o.checked).map(o => o.id);
      this.$post("/user/goodsOrder/payShop", ordersSelected)
          .then(() => {
            this.$toast.success(this.$t("Commit_Success"));
            this.reload();
          })
          .finally(() => {
            this.submiting = false;
          });
    },
    clickCate(index) {
      this.activeCateCode = index === 0 ? null : this.cates[index - 1].code;
      this.reload();
    },
    async getCateList() {
      let cates = (await getListCates()).data;
      if (cates.length) {
        // cates.unshift(All_CATE)
        this.cates = cates;
      }
    },
    clickState() {
      this.reload();
    },
    async reload() {
      this.current = 1;
      this.list = [];
      await this.getList();
    },
    clickCheckAll() {
      this.$nextTick(() => {
        //等数值变化了再保存到库/cookie中
        this.list.forEach(o => (o.checked = this.checkedAll));
      });
    },
    async getList() {
      if (!this.init) {
        return;
      }

      let goodsCateCode = this.activeCateCode;
      let searchText = this.searchText;
      let state = this.orderParam.state;
      state = state === 0 ? null : state;

      let res = await getGoodsOrder({
        isShopUser: this.pageFrom === "userShop",
        // ...eval("(" + this.filterObjStr + ")"),
        state,
        current: this.current,
        shopId: this.shopId === "undefined" ? null : this.shopId,
        goodsId: this.goodsId === "undefined" ? null : this.goodsId,
        size: this.size,
        searchText,
        // userId: this.pageFrom === 'user' ? this.userInfo.id : null,
        goodsCateCode
      });
      let data = res.data;
      data.records.forEach(r => (r.checked = false));
      this.total = parseInt(data.total);

      this.list = this.list.concat(data.records);
      if (this.total < this.current * this.size) {
        this.finished = true;
      }
      this.current++;
      console.log('this.list',this.list)
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    getGoodsOrderUpdatePre(address) {
      this.goodsOrder.phone = address.phone;
      this.goodsOrder.receiver = address.receiver;
      this.goodsOrder.addressDetail = this.stringAppend([
        address.province,
        address.province,
        address.district,
        address.addressDetail
      ]);
      this.getGoodsOrderUpdate();
    },
    stringAppend(strs) {
      return strs.filter(s => s && s.length).join(" ");
    },
    getGoodsOrderUpdate() {
      // if (this.loading) {
      //   return
      // } else {
      //   this.loading = true
      // }
      getGoodsOrderUpdate({...this.goodsOrder, state: null}).then(res => {
        // this.loading = false
        this.showGoodsOrderUpdate = false;
        this.$toast.success(this.$t("Commit_Success"));
      });
    },
    handleUpdate(goodsOrder) {
      this.goodsOrder = goodsOrder;
      this.showGoodsOrderUpdate = true;
    },
    cancelOrder(item) {
      this.selectedOrderNo = item.no;
      this.$refs.cancelOrderModal.show();
    },
    requestRefund(item) {
      this.selectedOrderNo = item.no;
      this.$refs.requestRefundModal.show();
    },
    canRefund(item) {
      return item.canRefundFlag;
    }
  }
};
</script>
